module.exports = __webpack_public_path__ + "static/media/vicky-nguyen.18931546.jpg";